export const enum Permission {
  // Internal Workers
  ManageAllInternalWorkers = 'ManageAllInternalWorkers',
  SignAgreementAsEmployerRepresentative = 'SignAgreementAsEmployerRepresentative',
  // External Workers
  CreateExternalWorker = 'CreateExternalWorker',
  ManageAllExternalWorkersList = 'ManageAllExternalWorkersList',
  ManageAsAExternalWorker = 'ManageAsAExternalWorker',
  ManageMyExternalWorkersList = 'ManageMyExternalWorkersList',
  ManageMyExternalWorkersTimesheet = 'ManageMyExternalWorkersTimesheet',
  ManageAllExternalWorkersTimesheet = 'ManageAllExternalWorkersTimesheet',
  ViewAllExternalWorkers = 'ViewAllExternalWorkers',
  ViewExternalWorkerForm = 'ViewExternalWorkerForm',
  ViewMyExternalWorker = 'ViewMyExternalWorker',
  EditExternalWorkerForm = 'EditExternalWorkerForm',
  ViewWorkersList = 'ViewWorkersList',
  InternalWorkerRolesVisibility = 'InternalWorkerRolesVisibility',
  // Timesheets
  ApproveTimesheetAsExternalWorker = 'ApproveTimesheetAsExternalWorker',
  ApproveTimesheetAsWorker = 'ApproveTimesheetAsWorker',
  ApproveTimesheetAsInternalWorker = 'ApproveTimesheetAsInternalWorker',
  ApproveTimesheetAsInternalWorkerForAll ='ApproveTimesheetAsInternalWorkerForAll',
  ViewTimesheetsList = 'ViewTimesheetsList',
  ViewTimesheetsListEmptyTab = 'ViewTimesheetsListEmptyTab',
  ViewTimesheetsListToBeApprovedByInternalEmployeeTab = 'ViewTimesheetsListToBeApprovedByInternalEmployeeTab',
  ViewTimesheetsListToBeApprovedByExternalEmployeeTab = 'ViewTimesheetsListToBeApprovedByExternalEmployeeTab',
  ViewTimesheetsListToBeSettledTab = 'ViewTimesheetsListToBeSettledTab',
  ViewTimesheetsIsSentToExteralSystemFlag = 'ViewTimesheetsIsSentToExteralSystemFlag',
  SetAllTimesheetCorrection = 'SetAllTimesheetCorrection',
  SetMyExternalWorkerTimesheetCorrection = 'SetMyExternalWorkerTimesheetCorrection',
  GenerateAllExternalWorkersTimesheetDocument = 'GenerateAllExternalWorkersTimesheetDocument',
  GenerateMyExternalWorkersTimesheetDocument = 'GenerateMyExternalWorkersTimesheetDocument',
  // Common
  DeleteWorkerFiles = 'DeleteWorkerFiles',
  EditExternalWorkerConsents = 'EditExternalWorkerConsents',
  CanSaveSummaryWithoutConsents = 'CanSaveSummaryWithoutConsents',
  EditWorkersEmailAndPhoneNumber = 'EditWorkersEmailAndPhoneNumber',
  EditAlreadyActivatedWorkersEmailAndPhoneNumber = 'EditAlreadyActivatedWorkersEmailAndPhoneNumber',
  ManageHrNumber = "ManageHrNumber",
  VerifyWorkerFiles = 'VerifyWorkerFiles',
  // Worker profile
  ViewPersonalDataOnWorkerProfile = 'ViewPersonalDataOnWorkerProfile',
  ViewEducationHistoryDataOnWorkerProfile = 'ViewEducationHistoryDataOnWorkerProfile',
  ViewFamilyMemberDataOnWorkerProfile = 'ViewFamilyMemberDataOnWorkerProfile',
  ViewAdditaryPersonalDataOnWorkerProfile = 'ViewAdditaryPersonalDataOnWorkerProfile',
  ViewStatementsOnWorkerProfile = 'ViewStatementsOnWorkerProfile',
  ViewDocumentsOnWorkerProfile = 'ViewDocumentsOnWorkerProfile',
  ViewEmploymentHistoryOnWorkerProfile = 'ViewEmploymentHistoryOnWorkerProfile',
  ViewTimesheetOnWorkerProfile = 'ViewTimesheetOnWorkerProfile',
  ViewSettingsOnWorkerProfile = 'ViewSettingsOnWorkerProfile',

  AgreementPreview = 'AgreementPreview',
  AgreementPreviewMyExternalWorkers = 'AgreementPreviewMyExternalWorkers',
  AgreementPreviewAllExternalWorkers = 'AgreementPreviewAllExternalWorkers',
  AgreementDetails = 'AgreementDetails',
  ReplaceAgreement = 'ReplaceAgreement',
  PrintDraftVersionOfAgreement = 'PrintDraftVersionOfAgreement',
  ShouldReceiveAgreementTerminationNotification = 'ShouldReceiveAgreementTerminationNotification',
  TerminateMyAgreement = 'TerminateMyAgreement',
  TerminateMandateAgreement = 'TerminateMandateAgreement',
  TerminateTrialEmployment = 'TerminateTrialEmployment',
  TerminateFixedTermEmployment = 'TerminateFixedTermEmployment',
  TerminatePermanentEmployment = 'TerminatePermanentEmployment',
  TerminateTemporaryAgreement = 'TerminateTemporaryAgreement',
  ViewWorkerAgreementsList = 'ViewWorkerAgreementsList',
  CreateMultipleEmploymentAgreements = 'CreateMultipleEmploymentAgreements',
  ManageFamilyMemberInsuranceApplicationDate = 'ManageFamilyMemberInsuranceApplicationDate',
  SendMultipleWorkerAgreementsToApproval = 'SendMultipleWorkerAgreementsToApproval',
  // Absences
  AcceptWorkerAbsences = 'AcceptWorkerAbsences',
  BackToDraftMyAbsences = 'BackToDraftMyAbsences',
  BackToDraftWorkerAbsences = 'BackToDraftWorkerAbsences',
  ConfirmMyAbsences = 'ConfirmMyAbsences',
  ConfirmWorkerAbsences = 'ConfirmWorkerAbsences',
  DeleteMyAbsences = 'DeleteMyAbsences',
  DeleteWorkerAbsences = 'DeleteWorkerAbsences',
  RejectWorkerAbsences = 'RejectWorkerAbsences',
  ViewWorkerAbsences = 'ViewWorkerAbsences',
  ViewAbsenceOnWorkerProfile = 'ViewAbsenceOnWorkerProfile',
  ViewMyAbsences = 'ViewMyAbsences',
  ViewMyDocuments = 'ViewMyDocuments',
  ViewWorkerDocuments = 'ViewWorkerDocuments',
  ViewDocumentsList = 'ViewDocumentsList',
  ShowIsSentToExteralSystemFilter = 'ShowIsSentToExteralSystemFilter',
  CancelMyWorkersAbsences = 'CancelMyWorkersAbsences',
  CancelGlobalWorkersAbsences = 'CancelGlobalWorkersAbsences',
  AllowSkippingPreviousMonthAbsenceLimit = 'AllowSkippingPreviousMonthAbsenceLimit',  
  ViewAbsencesList = 'ViewAbsencesList',
  
  //Supervisors
  Supervisor = 'Supervisor',
  AddSupervisorOnWorkerProfile = 'AddSupervisorOnWorkerProfile',
  EditSupervisorOnWorkerProfile = 'EditSupervisorOnWorkerProfile',
  DeleteSupervisorOnWorkerProfile = 'DeleteSupervisorOnWorkerProfile',
  ViewSupervisorsOnWorkerProfile = 'ViewSupervisorsOnWorkerProfile',
  //Delegations
  ManageMyDelegations = 'ManageMyDelegations',
  ManageWorkerDelegations = 'ManageWorkerDelegations',
  HRDelegationManagement = 'HRDelegationManagement',
  AccountingDelegationManagement = 'AccountingDelegationManagement',
  AccountingDelegationManagementAllAccess = 'AccountingDelegationManagementAllAccess',
  FullDelegationsManagement = 'FullDelegationsManagement',
  //Presences
  ViewPresences = 'ViewPresences', //Obsolete
  DisableAgreementDateLimit = 'DisableAgreementDateLimit',
  ViewAllPresencesPerDay = 'ViewAllPresencesPerDay',
  ViewMyExternalWorkerPresencesPerDay = 'ViewMyExternalWorkerPresencesPerDay',
  ViewAllPresencesPerMonth = 'ViewAllPresencesPerMonth',
  ViewMyExternalWorkerPresencesPerMonth = 'ViewMyExternalWorkerPresencesPerMonth',
  //Reports
  GenerateActiveEmployeesReport = 'GenerateActiveEmployeesReport',
  GenerateAllEmployeesInstitutionReport = 'GenerateAllEmployeesInstitutionReport',
  //Legalizations
  ShowAllLegalizations = 'ShowAllLegalizations',
  ShowEmployerObjectLegalizations = 'ShowEmployerObjectLegalizations',
  ManageLegalization = 'ManageLegalization',
  ViewLegalizationStatusOnWorkerProfile = 'ViewLegalizationStatusOnWorkerProfile',
  CorrectLegalizationEmployeeDocument = 'CorrectLegalizationEmployeeDocument',
  GetAllLegalizationDocuments = 'GetAllLegalizationDocuments',
  GetEmployerObjectLegalizationDocuments = 'GetEmployerObjectLegalizationDocuments',
  LegalizationInformationVisibilityToAll = 'LegalizationInformationVisibilityToAll',
  LegalizationInformationVisibilityToEmployerObjects = 'LegalizationInformationVisibilityToEmployerObjects',
  LegalizationDecision = 'LegalizationDecision',
  AddLegalizationDocument = 'AddLegalizationDocument',
  CorrectLegalizationDocumentByEmployee = 'CorrectLegalizationDocumentByEmployee',
  CorrectLegalizationDocumentByCoordinator = 'CorrectLegalizationDocumentByCoordinator',
  AddBasicLegalizationDocument = 'AddBasicLegalizationDocument',
  
  //Declarations
  ShowAllDeclarations = 'ShowAllDeclarations',
  ShowEmployerObjectDeclarations = 'ShowEmployerObjectDeclarations',
  ShareAllDeclarations = 'ShareAllDeclarations',
  ShareEmployerObjectDeclarations = 'ShareEmployerObjectDeclarations',

  //EmploymentConditionsConfirmation
  ViewAllExternalWorkerEmploymentConditionsConfirmation = 'ViewAllExternalWorkerEmploymentConditionsConfirmation',
  ViewMyExternalWorkerEmploymentConditionsConfirmation = 'ViewMyExternalWorkerEmploymentConditionsConfirmation',
  SignEmploymentConditionsConfirmation = 'SignEmploymentConditionsConfirmation',
  CreateEmploymentConditionsConfirmation = 'CreateEmploymentConditionsConfirmation',
  //Reports
  ManageReports = 'ManageReports',

  //MandateAgreementWorkedDay
  ViewAllMandateAgreementWorkedDays = 'ViewAllMandateAgreementWorkedDays',
  ViewMyExternalWorkerMandateAgreementWorkedDays = 'ViewMyExternalWorkerMandateAgreementWorkedDays',
  ViewMyMandateAgreementWorkedDays = "ViewMyMandateAgreementWorkedDays",

  //QrCodes
  QrCode = 'QrCode',

  //Holidays
  ViewAllExternalWorkersHolidaysList = "ViewAllExternalWorkersHolidaysList",
  ViewMyExternalWorkersHolidaysList = "ViewMyExternalWorkersHolidaysList",

  //Statistics
  ManageStatistics = 'ManageStatistics',

  //Orders
  ManageEmployeesOrder = 'ManageEmployeesOrder',
  AssignOrderToAgreement = 'AssignOrderToAgreement',
  ManageOrderStartRealization = 'ManageOrderStartRealization',
  ManageOrderRealization = 'ManageOrderRealization',
  CreateOrder = 'CreateOrder',
  ChangeOrderItemWorkerRealizationDate = 'ChangeOrderItemWorkerRealizationDate',
  EditOrderItem = 'EditOrderItem',
  ArchiveRestoreOrderItem = 'ArchiveRestoreOrderItem',

  //AbsenceApproval
  AcceptAbsenceWithDecisiveNegative = 'AcceptAbsenceWithDecisiveNegative',
  AcceptAbsenceWithDecisiveBoth = 'AcceptAbsenceWithDecisiveBoth',

  //Agreement Annex
  CreateAnnex = 'CreateAnnex',
  DisableAnnexDateValidation = "DisableAnnexDateValidation",
  ViewAnnexRegistry = 'ViewAnnexRegistry',
  
  //Talentina
  Talentina = 'Talentina',
  TalentinaEmployee = 'TalentinaEmployee',

  //Admin
  ImportFromExternalSystem = 'ImportFromExternalSystem',
}

export type PermissionLike = Permission | `${Permission}`;
